// extracted by mini-css-extract-plugin
export var container = "bib-horaire-module--container--f9eae";
export var hour = "bib-horaire-module--hour--a866b";
export var hourSpan = "bib-horaire-module--hourSpan--e90f9";
export var line = "bib-horaire-module--line--cc807";
export var link = "bib-horaire-module--link--b9344";
export var root = "bib-horaire-module--root--739a6";
export var shine = "bib-horaire-module--shine--8bb48";
export var title = "bib-horaire-module--title--d8310";
export var titleWait = "bib-horaire-module--titleWait--d48c3";
export var wait = "bib-horaire-module--wait--ba465";